import { mapRasse, mapRassen } from '@ps20-frontend/migrations';
import { Versicherungsnehmer } from '../reducers/versicherungsnehmer.reducer';
import { StatePreV8, StateV8 } from './8_migrate_rasse.interface';

export const migrateRassen = (previousState: StatePreV8, newVersion: number): StateV8 => {
  return {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      rasseEinHund: mapRasse(previousState.versicherungsnehmer.rasseEinHund),
      rasseMehrereHunde: mapRassen(previousState.versicherungsnehmer.rasseMehrereHunde),
    } as Versicherungsnehmer,
  };
};
